import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\BundleController::index
* @see app/Http/Controllers/Creator/BundleController.php:20
* @route '/app/creator/bundles'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/creator/bundles',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\BundleController::index
* @see app/Http/Controllers/Creator/BundleController.php:20
* @route '/app/creator/bundles'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\BundleController::index
* @see app/Http/Controllers/Creator/BundleController.php:20
* @route '/app/creator/bundles'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::index
* @see app/Http/Controllers/Creator/BundleController.php:20
* @route '/app/creator/bundles'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::index
* @see app/Http/Controllers/Creator/BundleController.php:20
* @route '/app/creator/bundles'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::index
* @see app/Http/Controllers/Creator/BundleController.php:20
* @route '/app/creator/bundles'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::index
* @see app/Http/Controllers/Creator/BundleController.php:20
* @route '/app/creator/bundles'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Creator\BundleController::store
* @see app/Http/Controllers/Creator/BundleController.php:37
* @route '/app/creator/bundles'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/bundles',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\BundleController::store
* @see app/Http/Controllers/Creator/BundleController.php:37
* @route '/app/creator/bundles'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\BundleController::store
* @see app/Http/Controllers/Creator/BundleController.php:37
* @route '/app/creator/bundles'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::store
* @see app/Http/Controllers/Creator/BundleController.php:37
* @route '/app/creator/bundles'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::store
* @see app/Http/Controllers/Creator/BundleController.php:37
* @route '/app/creator/bundles'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\BundleController::update
* @see app/Http/Controllers/Creator/BundleController.php:61
* @route '/app/creator/bundles/{bundle}'
*/
export const update = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/creator/bundles/{bundle}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\BundleController::update
* @see app/Http/Controllers/Creator/BundleController.php:61
* @route '/app/creator/bundles/{bundle}'
*/
update.url = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { bundle: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { bundle: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            bundle: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        bundle: typeof args.bundle === 'object'
        ? args.bundle.uuid
        : args.bundle,
    }

    return update.definition.url
            .replace('{bundle}', parsedArgs.bundle.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\BundleController::update
* @see app/Http/Controllers/Creator/BundleController.php:61
* @route '/app/creator/bundles/{bundle}'
*/
update.put = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::update
* @see app/Http/Controllers/Creator/BundleController.php:61
* @route '/app/creator/bundles/{bundle}'
*/
const updateForm = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::update
* @see app/Http/Controllers/Creator/BundleController.php:61
* @route '/app/creator/bundles/{bundle}'
*/
updateForm.put = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Creator\BundleController::destroy
* @see app/Http/Controllers/Creator/BundleController.php:78
* @route '/app/creator/bundles/{bundle}'
*/
export const destroy = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/bundles/{bundle}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\BundleController::destroy
* @see app/Http/Controllers/Creator/BundleController.php:78
* @route '/app/creator/bundles/{bundle}'
*/
destroy.url = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { bundle: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { bundle: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            bundle: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        bundle: typeof args.bundle === 'object'
        ? args.bundle.uuid
        : args.bundle,
    }

    return destroy.definition.url
            .replace('{bundle}', parsedArgs.bundle.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\BundleController::destroy
* @see app/Http/Controllers/Creator/BundleController.php:78
* @route '/app/creator/bundles/{bundle}'
*/
destroy.delete = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::destroy
* @see app/Http/Controllers/Creator/BundleController.php:78
* @route '/app/creator/bundles/{bundle}'
*/
const destroyForm = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\BundleController::destroy
* @see app/Http/Controllers/Creator/BundleController.php:78
* @route '/app/creator/bundles/{bundle}'
*/
destroyForm.delete = (args: { bundle: string | { uuid: string } } | [bundle: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const bundles = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default bundles